import clsx from 'clsx'

/* styling */
import styles from './_.module.css'

interface Props {
  content: string
  className?: string
}

const RichTextContent = (props: Props): JSX.Element => {
  return (
    <div
      className={clsx('mb-4', styles.richTextContainer, props.className)}
      dangerouslySetInnerHTML={{ __html: props.content }}
    />
  )
}

export default RichTextContent
